export const okstate_valid_email_extensions = [
    'okstate.edu',
    'alumni.okstate.edu',
    'ostate.tv',
    'osugiving.com',
    'orangeconnection.org',
    'okstatealumni.org',

    // Add more emails extensions here
];